import { CreateCoverImage, CreateProductFormat, CreateTerms } from '../interfaces/create-custom-product.interface';
import { parse } from '../../../common/utils/util';

/**
 * Maps the cover images retrieved from Magento to the CreateCoverImage interface.
 *
 * @param coverImages
 */
export const mapCreateCoverImages = (coverImages?: any[]): CreateCoverImage[] => {
  return (
    coverImages?.map((image: any) => ({
      alt: image.alt,
      httpUrl: image.http_url,
      type: image.type,
    })) || []
  );
};

/**
 * Maps the Create product format received from API responses.
 *
 * @param createDeliveryTypes
 */
export const mapJsonCreateProductFormat = (createDeliveryTypes?: string): string => {
  return mapCreateProductFormat(parse(createDeliveryTypes) || []);
};

/**
 * Maps the Create delivery types to a user-friendly format for display on the product card.
 *
 * @param createDeliveryTypes
 */
export const mapCreateProductFormat = (createDeliveryTypes: string[]): string => {
  for (const type of createDeliveryTypes) {
    switch (type) {
      case CreateProductFormat.VITALSOURCE_DONLOAD:
      case CreateProductFormat.VITALSOURCE_DOWNLOAD:
      case CreateProductFormat.VITALSOURCE_ONLINE:
        return 'Vital Source eBook';
      case CreateProductFormat.MHE_READER:
        return 'MH eBook';
    }
  }

  return '';
};

/**
 * Maps the terms for a Create product to the duration and duration period.
 *
 * @param terms
 */
export const mapCreateTermsToDuration = (terms?: string): any => {
  const createTerms: CreateTerms | undefined = parse(terms);
  if (createTerms) {
    return {
      duration: createTerms.days,
      durationPeriod: 'Day',
    }
  }

  return {}
};
